import styled from 'styled-components';
import { Container } from '../../styles/Common';

const BoxWrapper1 = () => {
  return (
    <>
      <Container>
        <Wrapper>
          <CardWrapper>
            <SingleCard>
              <div className="top">
                <img src="/assets/icons/envelop.png" alt="envelop" />
                <h2>Fulfillment</h2>
              </div>
              <p className="text">
                We combine the value of a low-cost fulfillment solution with
                high-tech shipping software to reduce shipping costs and deliver
                packages quickly to customers.
              </p>
            </SingleCard>
            <SingleCard>
              <div className="top">
                <img src="/assets/icons/announce.png" alt="envelop" />
                <h2>Fulfillment By Amazon</h2>
              </div>
              <p className="text">
                We provide Amazon FBA Prep, Merchant Fulfillment, and Storage
                Services to clients selling products on Amazon or through the
                eCommerce market.
              </p>
            </SingleCard>
            <SingleCard>
              <div className="top">
                <img src="/assets/icons/cloud.png" alt="envelop" />
                <h2>Shipping</h2>
              </div>
              <p className="text">
                We work closely with the United States Postal Services to offer
                negotiated/discounted rates to our customers for services they
                would not qualify for independently.
              </p>
            </SingleCard>
            <SingleCard>
              <div className="top">
                <img src="/assets/icons/envelop.png" alt="envelop" />
                <h2>Warehousing</h2>
              </div>
              <p className="text">
                With our strategic storage patterns. we make it simple for our
                customers to phase inventory in and out with the season or as
                demand fluctuates.
              </p>
            </SingleCard>
            <SingleCard>
              <div className="top">
                <img src="/assets/icons/announce.png" alt="envelop" />
                <h2>Transportation + Logistics</h2>
              </div>
              <p className="text">
                Our capable network is knowledgable in customs regulations and
                clearing processes with U.S. Customs and other government
                agencies.
              </p>
            </SingleCard>
            <SingleCard>
              <div className="top">
                <img src="/assets/icons/cloud.png" alt="envelop" />
                <h2>Packaging + Shipping Supplies</h2>
              </div>
              <p className="text">
                We provide packaging options such as pick and pack and
                display/kit building to cover all different types of inventory.
              </p>
            </SingleCard>
          </CardWrapper>
        </Wrapper>
      </Container>
    </>
  );
};

export default BoxWrapper1;

const Wrapper = styled.div`
  padding: 80px 0;

  @media (max-width: 576px) {
    padding: 40px 0;
  }
`;

const CardWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0;

  @media (max-width: 576px) {
    padding: 0 15px;
  }
`;

const SingleCard = styled.div`
  width: 32%;
  background: #ffffff;
  box-shadow: 30px 40px 60px rgba(0, 0, 0, 0.06);
  border-radius: 15px;
  padding: 30px 30px 45px 30px;
  display: flex;
  flex-direction: column;
  transition: 0.3s;
  margin-bottom: 40px;

  .top {
    flex-direction: column;
    display: flex;
    align-items: center;
    margin-bottom: 30px;

    img {
      width: 130px;
      height: auto;
      margin-bottom: 35px;
    }

    h2 {
      font-weight: 600;
      font-family: font-semibold;
      font-size: 25px;
      color: #000000;
      text-align: center;
      line-height: 1.4;
      transition: 0.3s;
    }
  }

  p.text {
    font-weight: 500;
    font-family: font-medium;
    font-size: 18px;
    text-align: center;
    color: rgb(152, 159, 179);
    line-height: 1.7;
    transition: 0.3s;
  }

  &:hover {
    background: #5da5ed;

    .top {
      h2 {
        color: #fff;
      }
    }

    p.text {
      color: #fff;
    }
  }

  @media (max-width: 576px) {
    width: 100%;
    margin-bottom: 25px;
    padding: 20px 20px 35px 20px;

    .top {
      margin-bottom: 20px;

      img {
        width: 100px;
        height: auto;
        margin-bottom: 25px;
      }

      h2 {
        font-size: 22px;
      }
    }
  }
`;
